import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import ReactQueryInfiniteTable from '../../../../../../components/ReactQueryInfiniteTable';
import LoadingSpinner from '../../../../../../components/Spinner';
import { useInsuredArchivedRecordsData } from '../../../../../../services/insured-service';
import { COLUMNS } from '../../RecordsBody/columns';

const ArchivedRecordsModal = ({ insuredId }) => {
  const archivedInsuranceRequirementsData = useInsuredArchivedRecordsData({ insuredId });
  const { isLoading } = archivedInsuranceRequirementsData;

  const columns = useMemo(() => COLUMNS.filter(col => !['recordWatchers', 'recordStatus'].includes(col?.id)), [COLUMNS]);

  if (isLoading) {
    return (
      <Box height="150px">
        <LoadingSpinner />
      </Box>
    );
  }

  return (
    <Box>
      <ReactQueryInfiniteTable height="475px" reactQueryResponse={archivedInsuranceRequirementsData} tableColumns={columns} />
    </Box>
  );
};

ArchivedRecordsModal.propTypes = { insuredId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired };

export default ArchivedRecordsModal;
